import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { IconDictionaryService } from 'src/app/services/icon-dictionary.service';
import { FieldComponent } from 'tuain-ng-forms-lib';

const SEARCH_ICON = 'SEARCH';
@Component({
  selector: 'app-input-search',
  templateUrl: './app-input-search.component.html',
})
export class AppInputSearchComponent extends FieldComponent implements OnInit {
  @Input() prefixIcon = '';
  @ViewChild('inputElement', { static: true }) inputElement: ElementRef;

  searchIcon: string;

  constructor(public _iconDictionary: IconDictionaryService) {
    super();
    this.searchIcon = this._iconDictionary.mapIcon(SEARCH_ICON);
  }

  override focus() {
    if (this.inputElement) {
      this.inputElement.nativeElement.focus();
    }
  }

  openSearch() {
    this.onShowInfo('selectProduct');
  }
}
